import { UPLOAD_FILE_STATUSES } from "src/constants/statuses";
import { IAsset, ISection } from "@interfaces/courseElements";
import { VALIDATION_ERRORS } from "../../constants/VALIDATION_ERRORS";
import { emailRegexp, nameRegexp, numbersRegexp, russianPhoneRegexp } from "@shared/constants/regExp";

// TODO: Стоит вынести регулярки в отдельный файл

export const Rules = {
	email: () => {
		return {
			name: "email",
			validator: (value: string) => {
				return emailRegexp.test(value);
			},
			errorText: VALIDATION_ERRORS.NOT_VALID_EMAIL_FORMAT,
		};
	},
	phone: () => {
		return {
			name: "phone",
			validator: (value: string) => {
				return numbersRegexp.test(value);
			},
			errorText: VALIDATION_ERRORS.NOT_VALID_PHONE_FORMAT,
		};
	},

	russianPhone: () => {
		return {
			name: "russianPhone",
			validator: (value: string) => {
				return russianPhoneRegexp.test(value);
			},
			errorText: VALIDATION_ERRORS.NOT_VALID_PHONE_FORMAT,
		};
	},
	confirmation: () => {
		return {
			name: "confirmation",
			validator: (confirmation: string, { password }: { password: string }) => {
				return confirmation === password;
			},
			errorText: VALIDATION_ERRORS.PASSWORD_NOT_MATCH,
		};
	},
	password: () => {
		return {
			name: "password",
			validator: (value: string) => {
				return Boolean(value);
			},
			errorText: VALIDATION_ERRORS.NO_PASSWORD_VALUE,
		};
	},
	passwordLess8: (isRequired = true) => {
		return {
			name: VALIDATION_ERRORS.PASSWORD_LESS_8,
			validator: isRequired
				? (value: string) => {
						return value.length >= 8;
				  }
				: (value: string) => {
						return Boolean(value) ? value.length >= 8 : true;
				  },
			errorText: VALIDATION_ERRORS.PASSWORD_LESS_8,
		};
	},
	passwordMore16: (isRequired = true) => {
		return {
			name: VALIDATION_ERRORS.PASSWORD_MORE_16,
			validator: isRequired
				? (value: string) => {
						return value.length <= 16;
				  }
				: (value: string) => {
						return Boolean(value) ? value.length <= 16 : true;
				  },
			errorText: VALIDATION_ERRORS.PASSWORD_MORE_16,
		};
	},
	name: (isRequired = true) => {
		return {
			name: "name",
			validator: isRequired
				? (value: string) => {
						return nameRegexp.test(value.trim());
				  }
				: (value: string) => {
						return Boolean(value) ? nameRegexp.test(value) : true;
				  },
			errorText: VALIDATION_ERRORS.INCORRECT_NAME,
		};
	},
	required: (errorMessage?: string, min?: number) => {
		return {
			name: "required",
			validator: (value: string | number) => {
				if (min) return (value?.toString().trimEnd()).length >= min;
				return !!value && Boolean(value?.toString()) && value !== "null";
			},
			errorText: errorMessage ? errorMessage : VALIDATION_ERRORS.REQUIRED_VALUE,
		};
	},
	price: (errorMessage?: string) => {
		return {
			name: "required",
			validator: (value: string | number) => {
				return Boolean(value?.toString()) && value.toString() !== "null";
			},
			errorText: errorMessage ? errorMessage : VALIDATION_ERRORS.REQUIRED_VALUE,
		};
	},
	minValue: (minValue: number) => {
		return {
			name: "minValue",
			validator: (value: string[]) => {
				let filledFields = 0;
				value.forEach((field) => {
					if (field.length > 3) filledFields += 1;
				});
				return filledFields >= minValue && filledFields === value.length;
			},
			errorText: "Заполните все поля. Мин. кол-во символов - 4.",
		};
	},
	rating: () => {
		return {
			name: "rating",
			validator: (value: number) => {
				return value !== 0;
			},
			errorText: VALIDATION_ERRORS.REQUIRED_RATING,
		};
	},
	sections: () => {
		return {
			name: "sections",
			validator: (value: Array<ISection>) => {
				let isAllSectionsWithAssets = true;
				let uploadedVideosAmount = 0;
				let lecturesAmount = 0;
				let testsAmount = 0;
				let filledQuestionsAmount = 0;
				let quizzesAmount = 0;
				let filledTermsAmount = 0;
				value?.forEach((section: ISection) => {
					if (section.assets?.length !== 0) {
						section.assets?.forEach((asset: IAsset) => {
							// validation for lectures and video for each lecture
							if (asset.hasOwnProperty("video")) {
								lecturesAmount++;
								if (
									asset.status !== UPLOAD_FILE_STATUSES.FAIL &&
									asset.status !== UPLOAD_FILE_STATUSES.NOT_ADDED
								)
									uploadedVideosAmount++;
							}
							// validation for tests
							if (asset.questions) {
								testsAmount++;
								if (asset.questions && asset.questions[0].value?.length !== 0) filledQuestionsAmount++;
							}
							// validation for quizzes
							if (asset.terms) {
								quizzesAmount++;
								if (asset.terms && asset.terms[0].value?.length !== 0) filledTermsAmount++;
							}
						});
					} else {
						isAllSectionsWithAssets = false;
						return;
					}
				});

				return (
					uploadedVideosAmount > 0 &&
					uploadedVideosAmount === lecturesAmount &&
					testsAmount === filledQuestionsAmount &&
					quizzesAmount === filledTermsAmount &&
					isAllSectionsWithAssets
				);
			},
			errorText: VALIDATION_ERRORS.FILL_SECTIONS,
		};
	},
};
